<template>
  <t-text-input
    v-bind="$attrs"
    ref="field"
    :label="noLabel ? '' : label"
    :rules="validationRules"
    :model-value="modelValue"
    type="text"
  />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from "vue";
import TTextInput from "@/components/core/TTextInput.vue";
import { ValidationRule } from "vuetify";
import { useRules } from "vuetify/labs/rules";
import { VTextField } from "vuetify/components";

interface Props {
  noLabel?: boolean;
  label?: string;
  rules?: ValidationRule[];
  modelValue?: string | null;
}

const {
  noLabel = false,
  label = "E-mail",
  rules = [],
  modelValue = undefined,
} = defineProps<Props>();

defineOptions({
  name: "TEmailInput",
  inheritAttrs: false,
});

// This should be InstanceType<typeof TTextInput>, but there's a weird typing issue
// with the exposed validate() function, so we use VTextField directly.
const field = useTemplateRef<VTextField>("field");

const validationRules = computed((): ValidationRule[] => {
  return [...rules, useRules().email("E-mail inválido")];
});

function validate(): Promise<boolean | string[]> {
  if (field.value == null) return Promise.resolve(false);
  return field.value.validate();
}

defineExpose({
  validate,
});
</script>
